// eslint-disable-next-line import/prefer-default-export
export const ROLE_PATH = 'auth.user.role.type';
